import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import filenameData from 'components/pagesContent/Chat/utils/filenameData'
import { ChatFileLink, ChatText, IconAttach, IconAttachMe } from '../../style.js'

const FileNameWrapper = styled.div`
  display: flex;
  font-weight: 700;
`

const FileBasename = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Extension = styled.div`
  flex-shrink: 0;
`

const File = ({ isMe, url, name }) => {
  const IconAttachment = ({ width, height, style = {} }) => {
    return isMe ? (
      <IconAttachMe width={width} height={height} style={style} />
    ) : (
      <IconAttach width={width} height={height} style={style} />
    )
  }

  const { basename, extension } = filenameData(name)

  return (
    <ChatFileLink href={url} isMe={isMe}>
      <IconAttachment width={32} height={32} style={{ flexShrink: 0 }} />
      <ChatText isMe={isMe} style={{ minWidth: 0 }}>
        <FileNameWrapper>
          <FileBasename>{basename}</FileBasename>
          <Extension>{extension}</Extension>
        </FileNameWrapper>
        <span>Klicka/tryck för att ladda ner</span>
      </ChatText>
    </ChatFileLink>
  )
}

File.propTypes = {
  isMe: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default File
